// Mock data pour Domus & Co

export const companyInfo = {
  name: "Domus & Co",
  tagline: "Rénovation Générale d'Intérieur",
  description: "Spécialiste de la rénovation intérieure tous corps d'état en Île-de-France",
  phone: "06 66 77 01 27",
  email: "concept.domus.co@gmail.com",
  address: "Île-de-France",
  serviceArea: "Toute l'Île-de-France"
};

export const services = [
  {
    id: 1,
    title: "Rénovation Complète",
    description: "Transformation totale de votre intérieur avec une coordination parfaite de tous les corps de métier.",
    icon: "Home",
    features: ["Démolition", "Gros œuvre", "Second œuvre", "Finitions"]
  },
  {
    id: 2,
    title: "Couverture et Charpente",
    description: "Expertise en charpente et couverture pour protéger durablement votre habitation.",
    icon: "Warehouse",
    features: ["Charpente sur mesure", "Couverture sur mesure", "Gouttières", "Nettoyage de charpente", "Traitement de charpente", "Zinguerie"]
  },
  {
    id: 3,
    title: "Plâtrerie",
    description: "Travaux de plâtrerie pour créer et aménager vos espaces intérieurs avec finesse.",
    icon: "Square",
    features: ["Cloison & doublage en BA13", "Isolation", "Faux plafond en BA13", "Plâtre gros et fin", "Moulure en plâtre"]
  },
  {
    id: 4,
    title: "Démolition / Déblai",
    description: "Service complet de démolition et évacuation des déchets de chantier.",
    icon: "Trash2",
    features: ["Démolition", "Déblai", "Transport des déchets", "Évacuation à la déchèterie"]
  },
  {
    id: 5,
    title: "Plomberie & Sanitaires",
    description: "Installation et rénovation de salles de bains, cuisines et systèmes de plomberie.",
    icon: "Droplets",
    features: ["Salles de bains", "Cuisines", "Chauffage", "Évacuation"]
  },
  {
    id: 6,
    title: "Électricité",
    description: "Mise aux normes électriques et installation de systèmes modernes et sécurisés.",
    icon: "Zap",
    features: ["Tableaux électriques", "Éclairage", "Prises", "Domotique"]
  },
  {
    id: 7,
    title: "Peinture & Décoration",
    description: "Travaux de peinture et décoration pour sublimer vos espaces de vie.",
    icon: "Paintbrush",
    features: ["Peinture murale", "Papiers peints", "Enduits", "Finitions"]
  },
  {
    id: 8,
    title: "Sols & Revêtements",
    description: "Pose de parquets, carrelages et tous types de revêtements de sol.",
    icon: "Layers",
    features: ["Parquet", "Carrelage", "Vinyle", "Moquette"]
  },
  {
    id: 9,
    title: "Menuiserie Intérieure",
    description: "Aménagements et menuiseries intérieures sur mesure pour embellir votre intérieur.",
    icon: "BoxSelect",
    features: ["Moulures & cimaises", "Plinthes & champlats", "Placards sur mesure", "Dressing sur mesure", "Agencement intérieur"]
  },
  {
    id: 10,
    title: "Menuiserie Extérieure",
    description: "Installation et remplacement de menuiseries extérieures en bois, aluminium ou PVC.",
    icon: "DoorOpen",
    features: ["Fenêtres", "Portes fenêtres", "Portes d'entrée", "Portes de garage", "Volets roulants électriques", "Persiennes"]
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Salle de bain Luxe - 8ème",
    description: "Création d'une salle de bain moderne avec douche à l'italienne sur mesure, système de douche pluie et mitigeur tactile",
    image: "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/9iyqffk2_IMG_4109.jpeg",
    category: "Plomberie & Sanitaires",
    surface: "15m²",
    duration: "3 semaines",
    location: "Paris 8ème",
    year: "2024",
    client: "M. Dubois",
    gallery: [
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/9iyqffk2_IMG_4109.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/xwwv0gls_IMG_4110.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/gsvbbphq_IMG_4111.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/0wxdnsm8_IMG_4112.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/ik94nkpd_ddeb7e81-4427-4a9e-b7f3-2e26d4b7cb2a.jpeg"
    ],
    fullDescription: "Création d'une salle de bain contemporaine haut de gamme alliant technologie et design. Ce projet se distingue par une douche à l'italienne entièrement sur mesure, sans aucun receveur, avec un système de douche pluie intégré au plafond et un mitigeur thermostatique tactile de dernière génération. Les finitions en carrelage effet marbre et les niches éclairées créent une ambiance spa luxueuse et fonctionnelle.",
    tasks: [
      {
        title: "Préparation et étanchéité",
        description: "Traitement complet de l'étanchéité du sol et des murs, préparation du support pour recevoir le carrelage en pente"
      },
      {
        title: "Douche à l'italienne sur mesure",
        description: "Création d'une douche à l'italienne sans receveur : carrelage découpé avec précision et posé en pente douce vers le siphon de sol pour assurer un écoulement parfait de l'eau. Aucun dénivelé visible, continuité totale du sol pour un effet moderne et épuré"
      },
      {
        title: "Système de douche pluie",
        description: "Installation d'une douche effet pluie intégrée au plafond : l'eau tombe verticalement du plafond pour une expérience de douche immersive et relaxante. Pommeau de tête extra-large pour un confort optimal"
      },
      {
        title: "Mitigeur thermostatique tactile",
        description: "Installation d'un mitigeur de douche haut de gamme avec écran tactile intégré. Le bouton de commande digital affiche la température exacte de l'eau en temps réel et permet de régler l'intensité du débit avec précision. Technologie moderne pour un contrôle total et une sécurité maximale"
      },
      {
        title: "Niches de rangement éclairées",
        description: "Création de niches murales encastrées avec spots LED intégrés pour un éclairage d'ambiance chaleureux. Espaces de rangement pratiques et design pour shampoings, gels douche et accessoires de toilette. Finition soignée avec encadrement en inox brossé"
      },
      {
        title: "WC suspendu design",
        description: "Installation d'un WC suspendu avec bâti-support Geberit encastré dans le mur. Design minimaliste et moderne, plaque de commande double touche blanche. Gain de place et facilité d'entretien pour une salle de bain épurée et élégante"
      },
      {
        title: "Revêtements et finitions",
        description: "Pose de carrelage grand format effet marbre beige sur les murs et au sol. Joints fins et alignement parfait pour une finition luxueuse. Murs blancs laqués pour un contraste moderne"
      }
    ],
    features: [
      "Douche à l'italienne sans receveur",
      "Carrelage posé en pente naturelle",
      "Douche pluie au plafond",
      "Mitigeur tactile avec écran digital",
      "Affichage température et intensité",
      "Niches éclairées par spots LED",
      "WC suspendu Geberit",
      "Design moderne et épuré"
    ]
  },
  {
    id: 2,
    title: "Rénovation Générale Complète - 7ème",
    description: "Rénovation totale tous corps d'état d'un appartement non rénové depuis 20 ans : remise à neuf complète et modernisation",
    image: "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/lcoitic3_f2e153c4-bb2e-40d6-86b8-35872a7688cf.jpeg",
    category: "Rénovation Complète",
    surface: "60m²",
    duration: "2 mois",
    location: "Paris 7ème",
    year: "2024",
    client: "M. et Mme D.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/lcoitic3_f2e153c4-bb2e-40d6-86b8-35872a7688cf.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/pjf912vg_f9b21984-0e9a-4e60-8838-232d91e2c800.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/d59exdsb_f6e410ba-e455-428e-aed1-e5bd9fb04e82.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/dgmtdudc_fd2c0059-fd82-4ba8-a8e3-ef26d64b3770.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/20ddq5ug_afcf2b34-3d08-46ae-ae9e-f4e0d2370b15.jpeg"
    ],
    fullDescription: "Projet de rénovation générale complète d'un appartement parisien qui n'avait pas été rénové depuis 20 ans. Nous avons remis l'ensemble de l'appartement au goût du jour avec une intervention sur tous les corps de métier : électricité, plomberie, chauffage, plâtrerie, sols (parquet et carrelage), menuiserie intérieure et extérieure, ainsi que démolition et déblai. Un chantier complet qui a transformé cet appartement vieillissant en un espace moderne, fonctionnel et élégant.",
    tasks: [
      {
        title: "Démolition et déblai",
        description: "Démolition des cloisons non porteuses, dépose des anciens équipements, évacuation complète des gravats et déchets de chantier vers la déchèterie"
      },
      {
        title: "Électricité",
        description: "Refonte totale de l'installation électrique aux normes actuelles, nouveau tableau électrique, spots LED encastrés, bandeaux LED décoratifs, prises USB intégrées"
      },
      {
        title: "Plomberie et chauffage",
        description: "Remplacement complet de la plomberie, installation d'une nouvelle salle de bain avec douche à l'italienne et WC suspendu Geberit, modernisation du système de chauffage"
      },
      {
        title: "Plâtrerie",
        description: "Création de nouvelles cloisons en BA13, doublage, isolation thermique et acoustique, faux plafonds avec spots LED, lissage et enduit des murs"
      },
      {
        title: "Parquet, carrelage et faïence",
        description: "Pose de parquet stratifié effet chêne dans les pièces de vie et chambres, carrelage effet bois au sol de la salle de bain, faïence murale moderne"
      },
      {
        title: "Menuiserie intérieure",
        description: "Installation de placards sur mesure, dressing avec portes miroirs, moulures et plinthes, pose de portes intérieures neuves"
      },
      {
        title: "Menuiserie extérieure",
        description: "Remplacement des fenêtres et portes-fenêtres pour une meilleure isolation thermique et acoustique"
      },
      {
        title: "Peinture et finitions",
        description: "Peinture complète des murs et plafonds en blanc et gris, finitions soignées sur tous les raccords et détails"
      }
    ],
    features: [
      "Rénovation tous corps d'état",
      "Appartement remis à neuf",
      "Électricité aux normes",
      "Plomberie moderne",
      "Isolation renforcée",
      "Menuiseries neuves",
      "Design contemporain",
      "Matériaux de qualité"
    ]
  },
  {
    id: 3,
    title: "Rénovation Post-Sinistre - Île-de-France",
    description: "Réhabilitation complète d'un appartement après incendie : reconstruction et remise à neuf totale",
    image: "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/zx4ren2k_IMG_3482.jpeg",
    category: "Rénovation Complète",
    surface: "38m²",
    duration: "3 mois",
    location: "Île-de-France",
    year: "2024",
    client: "Sinistre assuré",
    gallery: [
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/zx4ren2k_IMG_3482.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/2f4oa72c_IMG_3483.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/x6x71vjo_IMG_3484.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/t8e9wlk6_IMG_3485.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/grmvfgr6_IMG_3486.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/4ekcngy1_IMG_3467.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/ftg1bj6c_IMG_3468.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/2efcsr8l_IMG_3470.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/klqawws9_IMG_3474.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/hknhsauw_IMG_3475.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/tyrvwm1l_IMG_3469.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/2zul71w8_IMG_3471.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/h2htuzjl_IMG_3473.jpeg"
    ],
    fullDescription: "Ce projet délicat concernait la réhabilitation complète d'un appartement ayant subi un incendie important. Nos équipes sont intervenues pour reconstruire entièrement l'espace endommagé et redonner vie à cet appartement sinistré. Une expertise technique et un savoir-faire rigoureux ont été nécessaires pour mener à bien cette renaissance.",
    tasks: [
      {
        title: "Dépose et décontamination",
        description: "Évacuation des matériaux brûlés, nettoyage et décontamination complète des surfaces touchées par l'incendie et la suie"
      },
      {
        title: "Plâtrerie",
        description: "Reconstruction complète des cloisons et plafonds en plaques de plâtre BA13, doublage, isolation thermique et acoustique renforcée"
      },
      {
        title: "Électricité",
        description: "Refonte totale de l'installation électrique avec passage du Consuel et mise en conformité aux normes NF C 15-100, nouveau tableau électrique, câblage complet"
      },
      {
        title: "Plomberie",
        description: "Installation complète à neuf de la plomberie : arrivées et évacuations d'eau, création d'une nouvelle salle de bain fonctionnelle et moderne"
      },
      {
        title: "Menuiserie extérieure",
        description: "Remplacement des fenêtres et portes-fenêtres endommagées par l'incendie, installation de menuiseries isolantes conformes"
      },
      {
        title: "Menuiserie intérieure",
        description: "Pose de nouvelles portes intérieures, plinthes et chambranles, installation de placards"
      },
      {
        title: "Parquet",
        description: "Pose d'un parquet en chêne massif dans toutes les pièces de vie pour un rendu chaleureux et durable"
      },
      {
        title: "Peinture et finitions",
        description: "Application de peintures anti-odeur et finitions complètes sur l'ensemble des surfaces pour effacer toute trace du sinistre"
      },
      {
        title: "Cuisine, décoration et aménagement intérieur",
        description: "Installation d'une cuisine moderne avec meubles bleus design, création de moulures décoratives murales, pose de panneaux acoustiques en bois (claustra), éclairage LED encastré, aménagement sur mesure pour optimiser l'espace"
      }
    ],
    features: [
      "Reconstruction post-incendie",
      "Consuel électrique validé",
      "Mise en conformité totale",
      "Parquet chêne massif",
      "Plomberie refaite à neuf",
      "Menuiseries neuves",
      "Décontamination complète",
      "Garantie décennale"
    ]
  },
  {
    id: 4,
    title: "Escalier de Luxe en Béton - Île-de-France",
    description: "Création complète d'un escalier en béton sur mesure avec habillage acoustique et éclairage LED intégré",
    image: "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/yawwss5g_IMG_3499.jpeg",
    category: "Menuiserie",
    surface: "N/A",
    duration: "5 semaines",
    location: "Île-de-France",
    year: "2024",
    client: "Résidence privée",
    gallery: [
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/tvp504hg_IMG_3494.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/whzytv2d_IMG_3495.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/6nmh03qs_IMG_3496.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/4gmcwn5f_IMG_3497.jpeg",
      "https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/yawwss5g_IMG_3499.jpeg"
    ],
    fullDescription: "Projet ambitieux de création d'un escalier en béton sur mesure réalisé entièrement par nos équipes. De la conception à la finition, chaque étape a été exécutée avec précision pour créer un escalier design et fonctionnel. L'intégration d'un habillage mural acoustique en panneaux de bois et d'un système d'éclairage LED encastré fait de cet escalier une pièce maîtresse architecturale alliant esthétique et technologie.",
    tasks: [
      {
        title: "Ferraillage et structure",
        description: "Mise en place et scellement du ferraillage métallique pour assurer la solidité et la portance de l'escalier. Travail de précision pour garantir la géométrie parfaite de chaque marche"
      },
      {
        title: "Coffrages et moules de coulage",
        description: "Installation des coffrages en bois sur mesure pour créer la forme exacte de l'escalier. Préparation minutieuse des moules pour obtenir des marches aux dimensions parfaites"
      },
      {
        title: "Coulage et vibration du béton",
        description: "Coulage du béton haute résistance avec vibration mécanique pour éliminer les bulles d'air et assurer une structure homogène et solide. Maîtrise parfaite du timing et des techniques de coulage"
      },
      {
        title: "Finition lisse des marches",
        description: "Travail de finition des marches en béton pour obtenir une surface parfaitement lisse et uniforme. Ponçage et lissage minutieux de chaque marche pour un résultat haut de gamme"
      },
      {
        title: "Installation électrique intégrée",
        description: "Création des saignées et passage des câbles électriques dans le mur pour chaque spot LED. Alimentation électrique prévue et intégrée dans la structure murale pour un résultat invisible et professionnel"
      },
      {
        title: "Habillage mural acoustique et éclairage",
        description: "Installation de panneaux décoratifs en bois à lamelles verticales pour un effet acoustique et esthétique. Intégration de spots LED en bas de chaque marche pour un éclairage d'ambiance bleu sophistiqué"
      }
    ],
    features: [
      "Escalier béton sur mesure",
      "Ferraillage professionnel",
      "Finitions lisses haut de gamme",
      "Habillage bois acoustique",
      "Éclairage LED intégré",
      "Alimentation électrique encastrée",
      "Design contemporain",
      "Réalisation complète"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sophie M.",
    location: "Paris 16ème",
    rating: 5,
    date: "Il y a 2 mois",
    text: "Excellent travail ! L'équipe de Domus & Co a réalisé la rénovation complète de notre appartement. Professionnalisme, respect des délais et qualité irréprochable. Je recommande vivement.",
    project: "Rénovation complète"
  },
  {
    id: 2,
    name: "Jean D.",
    location: "Paris 17ème",
    rating: 4,
    date: "Il y a 1 mois",
    text: "Très satisfait de la prestation. Les artisans sont qualifiés et à l'écoute. Notre salle de bain est magnifique. Petit délai de démarrage mais le résultat final est impeccable.",
    project: "Rénovation salle de bain"
  },
  {
    id: 3,
    name: "Marie L.",
    location: "Paris 8ème",
    rating: 5,
    date: "Il y a 3 semaines",
    text: "Entreprise sérieuse et professionnelle. La rénovation de notre parquet a été réalisée avec soin. Communication excellente du début à la fin. Je recommande sans hésiter.",
    project: "Réfection parquet"
  },
  {
    id: 4,
    name: "Thomas R.",
    location: "Neuilly-sur-Seine",
    rating: 5,
    date: "Il y a 1 semaine",
    text: "Domus & Co a rénové la charpente de notre maison. Travail soigné, équipe compétente et prix honnête. Nous sommes ravis du résultat !",
    project: "Charpente et couverture"
  },
  {
    id: 5,
    name: "Claire P.",
    location: "Paris 7ème",
    rating: 5,
    date: "Il y a 2 semaines",
    text: "Je suis très contente de la rénovation électrique de mon appartement. Tout a été fait dans les règles de l'art. Équipe ponctuelle et très professionnelle.",
    project: "Mise aux normes électrique"
  },
  {
    id: 6,
    name: "Philippe B.",
    location: "Le Marais",
    rating: 4,
    date: "Il y a 1 mois",
    text: "Bon rapport qualité-prix. Les travaux de peinture ont été réalisés avec soin. J'aurais aimé un suivi un peu plus régulier mais globalement satisfait du résultat.",
    project: "Peinture et décoration"
  }
];

export const stats = [
  { label: "Projets Réalisés", value: "200+", icon: "CheckCircle" },
  { label: "Années d'Expérience", value: "15+", icon: "Award" },
  { label: "Clients Satisfaits", value: "98%", icon: "Heart" },
  { label: "Artisans Qualifiés", value: "25+", icon: "Users" }
];

export const process = [
  {
    step: 1,
    title: "Prise de Contact",
    description: "Contactez-nous pour un premier échange sur votre projet"
  },
  {
    step: 2,
    title: "Visite & Diagnostic",
    description: "Nous visitons votre bien pour évaluer les travaux nécessaires"
  },
  {
    step: 3,
    title: "Devis Gratuit",
    description: "Nous vous proposons un devis détaillé sans engagement"
  },
  {
    step: 4,
    title: "Réalisation",
    description: "Nos équipes réalisent vos travaux dans les règles de l'art"
  }
];
